import { useEffect, useState } from "react";
import React from "react";
import useDashboard from "../../hooks/useDashboard";
import ItemDropdown from "../../components/ItemDropdown";
import { BookingStatus } from "../../components/BookingStatus";
import AlertMessage from "../../components/AlertMessage";
import Breadcrumb from "../../components/Breadcrumb";
const Dashboard = () => {
  const {
    todayBookingsCount,
    totalpendingAppointments,
    totalCancelledAppointments,
    availableStaff,
    totalCustomer,
    nextHoliday,
    inProgressAppointments,
    barberList,
    nextAppointments,
    comingAppointments,
    pendingAppointments,
    moveComingAppoitment,
    setMoveComingAppoitment,
    onSelectMoveComingAppoitment,
    onChangeStatutTo,
    loading,
    setShowMessage,
    message,
    showMessage,
  } = useDashboard();
  const image_url = process.env.REACT_APP_Image_APP_URL;

  /*if (appointments.length === 0) return <div>...loading</div>;*/
  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Home" child="Dashboard" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        {/* Stats Cards */}
        <div className="row mb-4">
          <div className="col-12 col-md-6 col-lg-3  mb-3">
            <div className="card text-white bg-primary h-100">
              <div className="card-body">
                <h2 className="card-title">Today's Bookings</h2>
                <p className="display-4">{todayBookingsCount}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-3">
            <div className="card text-white bg-danger h-100">
              <div className="card-body">
                <h5 className="card-title">Today's Cancelled</h5>
                <p className="display-4">{totalCancelledAppointments}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-3">
            <div className="card text-white bg-warning h-100">
              <div className="card-body">
                <h5 className="card-title">Total Pendning</h5>
                <p className="display-4">{totalpendingAppointments}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-3">
            <div className="card text-white bg-success h-100">
              <div className="card-body">
                <h5 className="card-title">Staff Available</h5>
                <p className="display-4">{availableStaff}</p>
              </div>
            </div>
          </div>
          <div className="col-md-12  mb-3">
            <div className="card text-white bg-danger h-100">
              <div className="card-body">
                <h5 className="card-title">Total Customers</h5>
                <p className="display-4">{totalCustomer}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          {(barberList || []).map((b) => {
            const appointment = (nextAppointments || []).find(
              (a) => a.staff.id === b.id,
            );
            return (
              <div className="col-12 col-md-4  mb-3">
                <div className="card  h-100 shadow-sm border-0">
                  <img
                    src={`${image_url}/${b.photoUrl}`}
                    style={{ objectFit: "cover", height: "220px" }}
                    className="card-img-top"
                  />
                  <div className="card-body text-center">
                    <h5 className="card-title fw-bold mb-1">{b.name}</h5>
                    <p className="card-text text-muted fs-5">
                      {appointment?.refferenceCode}
                    </p>
                    {appointment &&
                      (appointment.status === 1 ? (
                        <div className="d-flex justify-content-center gap-3 mt-3">
                          <button
                            className="btn btn-outline-primary"
                            onClick={() =>
                              onChangeStatutTo(
                                appointment.id,
                                BookingStatus[0].id,
                              )
                            }
                          >
                            Pending
                          </button>
                          <button
                            className="btn btn-primary "
                            onClick={() =>
                              onChangeStatutTo(
                                appointment.id,
                                BookingStatus[2].id,
                              )
                            }
                          >
                            Start
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center gap-3 mt-3">
                          <button className="btn btn-outline-primary ">
                            Info
                          </button>
                          <button
                            className="btn btn-primary "
                            onClick={() =>
                              onChangeStatutTo(
                                appointment.id,
                                BookingStatus[3].id,
                              )
                            }
                          >
                            Done
                          </button>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-12 col-lg-4">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Upcoming Appointments</h5>
              </div>
              <ul className="list-group list-group-flush">
                {comingAppointments?.map((appt) => (
                  <li
                    key={appt.id}
                    className="list-group-item d-flex justify-content-between"
                  >
                    <div>
                      <strong>{appt.customer}</strong>
                      <strong> {appt.refferenceCode}</strong>
                      <strong> {appt.staff.name}</strong>
                      <br />
                      {appt.service.map((s) => (
                        <small>{s}</small>
                      ))}
                    </div>
                    <span>{appt.time.substring(0, 5)}</span>
                    <ItemDropdown
                      key={appt.id}
                      item={appt}
                      name={"Move"}
                      isOpen={moveComingAppoitment == appt.id ? true : false}
                      onToggle={setMoveComingAppoitment}
                      onSelect={onSelectMoveComingAppoitment}
                      values={[BookingStatus[2], BookingStatus[3]]}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* Upcoming Appointments */}
          <div className="col-12 col-lg-4">
            <div className="card   mb-4">
              <div className="card-header">
                <h5 className="mb-0">In progress Appointments</h5>
              </div>
              <ul className="list-group list-group-flush">
                {inProgressAppointments?.map((appt) => (
                  <li
                    key={appt.id}
                    className="list-group-item d-flex justify-content-between"
                  >
                    <div>
                      <strong>{appt.customer}</strong>
                      <strong> {appt.refferenceCode}</strong>
                      <strong> {appt.staff.name}</strong>
                      <br />
                      {appt.service.map((s) => (
                        <small>{s.name}</small>
                      ))}
                    </div>
                    <span>{appt.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Pending Appointments</h5>
              </div>
              <ul className="list-group list-group-flush">
                {pendingAppointments?.map((appt) => (
                  <li
                    key={appt.id}
                    className="list-group-item d-flex justify-content-between"
                  >
                    <div>
                      <strong>{appt.customer}</strong>
                      <strong> {appt.refferenceCode}</strong>
                      <strong> {appt.staff.name}</strong>
                      <br />
                      {appt.service.map((s) => (
                        <small>{s}</small>
                      ))}
                    </div>
                    <span>{appt.time.substring(0, 5)}</span>
                    <ItemDropdown
                      key={appt.id}
                      item={appt}
                      name={"Move"}
                      isOpen={moveComingAppoitment == appt.id ? true : false}
                      onToggle={setMoveComingAppoitment}
                      onSelect={onSelectMoveComingAppoitment}
                      values={[BookingStatus[1], BookingStatus[2]]}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        {/* Quick Actions */}
        <div className="row">
          <div className="col-md-3 mb-2">
            <button className="btn btn-success w-100">+ New Booking</button>
          </div>
          <div className="col-md-3 mb-2">
            <button className="btn btn-warning w-100 text-white">
              + Add Staff
            </button>
          </div>
          <div className="col-md-3 mb-2">
            <button className="btn btn-danger w-100">Mark Day Closed</button>
          </div>
          <div className="col-md-3 mb-2">
            <button className="btn btn-info w-100 text-white">
              View Reports
            </button>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default Dashboard;
